//@ts-nocheck
import { addLineItemImage } from '../lineitem/lineitem';
import { importStockPhoto } from './photo';
import { formatStockPhotoTitle } from './stockPhotoTitle';

export const attachStockPhotoToLineItem = async ({
  photo,
  lineItemId,
  tripId,
  seq,
  isLibrary = false
}) => {
  const imported = await importStockPhoto({
    provider: photo.provider,
    providerPhotoId: photo.providerPhotoId,
    pathReference: isLibrary ? 'library' : 'lineItem',
    ...(!isLibrary && { tripId, lineItemId })
  });
  if (!imported?.path || !imported?.fileName || !imported?.publicUrl) {
    throw new Error('Stock photo import returned incomplete image data');
  }
  // Keep the S3 key in resourcepath; imagename is the operator-facing label.
  return addLineItemImage(lineItemId, {
    imageurl: imported.publicUrl,
    resourcepath: `${imported.path}/${imported.fileName}`,
    imagename: photo.title ?? formatStockPhotoTitle(photo.altText),
    seq
  });
};
